import { RecentlyViewed } from '@theme/recently-viewed-products';
import { sectionRenderer } from '@theme/section-renderer';

// Layout section ID — accessible from any URL context including /search
const RENDERER_SECTION_ID = 'awe-recently-viewed-renderer';

class AweRecentlyViewed extends HTMLElement {
  connectedCallback() {
    this.#load();
  }

  async #load() {
    const productIds = RecentlyViewed.getProducts();
    if (productIds.length === 0) return;

    const url = new URL(Theme.routes.search_url, location.origin);
    url.searchParams.set('q', productIds.map((id) => `id:${id}`).join(' OR '));
    url.searchParams.set('type', 'product');

    try {
      const html = await sectionRenderer.getSectionHTML(RENDERER_SECTION_ID, false, url);

      const doc = new DOMParser().parseFromString(html, 'text/html');
      // Layout sections are wrapped in shopify-section-{id} div
      const rendered = doc.querySelector(`#shopify-section-${RENDERER_SECTION_ID}`);
      const hasProducts = rendered && rendered.innerHTML.trim().length > 0;

      if (hasProducts) {
        const content = this.querySelector('.section-resource-list__content');
        if (content) {
          content.insertAdjacentHTML('beforebegin', rendered.innerHTML);
        } else {
          this.insertAdjacentHTML('afterbegin', rendered.innerHTML);
        }
        this.removeAttribute('hidden');
      }
    } catch {
      // Silently fail — section stays hidden
    }
  }
}

if (!customElements.get('awe-recently-viewed-component')) {
  customElements.define('awe-recently-viewed-component', AweRecentlyViewed);
}
